export const SDGRef = [
    {
        ref: 'United Nations (2022). Sustainable Development Goals - 17 Goals to Transform Our World. Retrieved from https://www.un.org/sustainabledevelopment/',
    },
    {
        ref: 'United Nations (2022). Goal 2 - Zero Hunger. Retrieved from https://www.un.org/sustainabledevelopment/hunger/',
    },
    {
        ref: 'United Nations (2022). Goal 3 - Ensure healthy lives and promote well-being for all at all ages. Retrieved from https://www.un.org/sustainabledevelopment/health/',
    },
    {
        ref: 'United Nations (2022). Goal 4 - Quality Education. Retrieved from https://www.un.org/sustainabledevelopment/education/',
    },
    {
        ref: 'United Nations (2022). Goal 8 - Promote inclusive and sustainable economic growth, employment and decent work for all. Retrieved from https://www.un.org/sustainabledevelopment/economic-growth/ ',
    },
    {
        ref: 'United Nations (2022). Goal 12: Ensure sustainable consumption and production patterns. Retrieved from https://www.un.org/sustainabledevelopment/sustainable-consumption-production/',
    },
    {
        ref: 'United Nations (2022). Goal 14: Conserve and sustainably use the oceans, seas and marine resources. Retrieved from https://www.un.org/sustainabledevelopment/oceans/',
    },
    {
        ref: 'WHO. (n.d.). Targets of sustainable development goal 3. World Health Organization (WHO). https://www.who.int/europe/about-us/our-work/sustainable-development-goals/targets-of-sustainable-development-goal-3',
    },

    
]